import { gridMFT } from "../../constants/grid.layout";

/** seting action types */
export const actionTypes = {
  SAVE_CHANGES_GRID_LAYOUT: "SAVE_CHANGES_GRID_LAYOUT",
  SAVE_OLD_GRID_LAYOUT: "SAVE_OLD_GRID_LAYOUT",
  SAVE_CHANGES_FONT_SIZE_LAYOUT: "SAVE_CHANGES_FONT_SIZE_LAYOUT",
  SAVE_MOBILE_TAB: "SAVE_MOBILE_TAB",
  SAVE_CURRENT_BREAKPOINT: "SAVE_CURRENT_BREAKPOINT",
  SAVE_ORDERS_FILTER: "SAVE_ORDERS_FILTER",
  SAVE_LOCK_LAYOUT: "SAVE_LOCK_LAYOUT",
  RESET_LAYOUT: "RESET_LAYOUT",
  SAVE_DEPOSIT_WALLET_INFO: "SAVE_DEPOSIT_WALLET_INFO",
  SAVE_EXPIRED_TK_INFO: "SAVE_EXPIRED_TK_INFO",
  SAVE_DEPTH_OPTION: "SAVE_DEPTH_OPTION",
  SAVE_FAV_PAIR_LIST: "SAVE_FAV_PAIR_LIST",
  SAVE_SELECTED_PAIR_OPTIONS: "SAVE_SELECTED_PAIR_OPTIONS",
  SAVE_DELISTED_PAIRS_CHECKED: "SAVE_DELISTED_PAIRS_CHECKED",
  SAVE_PRESALE_PAIRS_CHECKED: "SAVE_PRESALE_PAIRS_CHECKED"
};

/*
 * Action creators for login
 */

export const saveMobileTab = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SAVE_MOBILE_TAB,
    data: data,
  });
};

export const saveCurrentBrackpoint = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SAVE_CURRENT_BREAKPOINT,
    data: data,
  });
};

export const saveChangeGridLayout = (data, isMFT = false) => (dispatch) => {
  const layout = isMFT ? gridMFT(data) : data;
  dispatch({
    type: actionTypes.SAVE_CHANGES_GRID_LAYOUT,
    data: layout
  });
};

export const saveOldGridLayout = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SAVE_OLD_GRID_LAYOUT,
    data: data,
  });
};

export const saveFontSizeLayout = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SAVE_CHANGES_FONT_SIZE_LAYOUT,
    data: data,
  });
};

export const saveOrdersFilter = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SAVE_ORDERS_FILTER,
    data: data
  })
}


export const saveLockLayout = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SAVE_LOCK_LAYOUT,
    data: data
  })
}

export const saveDepositWalletInfo = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SAVE_DEPOSIT_WALLET_INFO,
    data: data
  })
}

export const saveExpiredTKInfo = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SAVE_EXPIRED_TK_INFO,
    data: data
  })
}

export const saveDelistedPairChecked = (pairId: number) => (dispatch, getState) => {
  const delistedPairsChecked = getState().persist.delistedPairsChecked;
  dispatch({
    type: actionTypes.SAVE_DELISTED_PAIRS_CHECKED,
    data: [...delistedPairsChecked, pairId]
  })
}

export const savePresalePairChecked = (pairId: number) => (dispatch, getState) => {
  const presalePairChecked = getState().persist.presalePairChecked;
  dispatch({
    type: actionTypes.SAVE_PRESALE_PAIRS_CHECKED,
    data: [...presalePairChecked, pairId]
  })
}

export const saveDepthOption = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SAVE_DEPTH_OPTION,
    data: data,
  });
};

export const saveSelectedPairOptions = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SAVE_SELECTED_PAIR_OPTIONS,
    data: data,
  });
};

export const saveFavPairsList = (data) => (dispatch, getState) => {
  try {
    const favList = getState().persist.favPairList;
    let newfavList = [];
    if (favList) {
      newfavList = favList;
    }
    const { address, pair_key } = data;

    const oldFavindex = favList?.findIndex(
      (doc) => doc.address.toUpperCase() === address.toUpperCase() && doc.pair_key.toUpperCase() === pair_key.toUpperCase()
    );
    if (oldFavindex === -1) {
      newfavList.push(data);
    } else {
      newfavList.splice(oldFavindex, 1);
    }
    dispatch({
      type: actionTypes.SAVE_FAV_PAIR_LIST,
      data: newfavList,
    });
  } catch (error) {
    console.log("Error saveFavPairsList :", error);
  }
};